import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAuthUser from "../Hooks/useAuthUser";
import { formatDateTime } from "../../pages/Usage/usageFormat";
import {
  getMySendingStatus,
  subscribeSendingChanges,
} from "../../pages/Usage/usageApi";
import "./SendingPausedBanner.css";

const TENANT_ROLES = ["TENANT_ADMIN", "TENANT_USER"];

// A slim bar under the header on every page for tenant users while Hububble
// has paused their SMS sending. No button: only Hububble can resume.
const SendingPausedBanner = () => {
  const { t, i18n } = useTranslation();
  const { roles } = useAuthUser();
  const isTenant = (roles || []).some((role) => TENANT_ROLES.includes(role));
  const [sending, setSending] = useState(null);

  const load = useCallback(async () => {
    if (!isTenant) return;
    try {
      setSending(await getMySendingStatus());
    } catch (err) {
      // Keep the last known status; the banner is not critical.
    }
  }, [isTenant]);

  useEffect(() => {
    load();
    return subscribeSendingChanges(load);
  }, [load]);

  if (!isTenant || sending?.sendingStatus !== "paused") return null;

  return (
    <div className="sending-paused-banner" role="alert">
      <i className="ri-pause-circle-line fs-16"></i>
      <span>
        <strong className="me-2">{t("usage.pausedBanner.title")}</strong>
        {t("usage.pausedBanner.message", {
          time: sending.lastAction
            ? formatDateTime(sending.lastAction.at, i18n.language)
            : "",
        })}
      </span>
    </div>
  );
};

export default SendingPausedBanner;
